import { parseQuery, buildQuery } from '@calendly/http-tools'

/** Public profile event-type page opened with `?back=1`. */
export const isProfileEventTypeBackContext = ({ eventType, search, path, profileSlug }) => Boolean(
  eventType
  && profileSlug
  && parseInt(parseQuery(search).back, 10) === 1
  && eventType.public
  && path === '/:profileSlug/:eventTypeSlug'
)

const getLandingPageReferrer = () => (
  document?.referrer?.indexOf(`${document?.location?.origin}/d/`) === 0 ? document.referrer : null
)

/** URL for returning from an event-type booking page to the host’s event-type list (or landing referrer). */
export const buildProfileEventTypesListUrl = (profileSlug, search) => {
  const landingPageReferrer = getLandingPageReferrer()
  if (landingPageReferrer) {
    return landingPageReferrer
  }
  const params = parseQuery(search)
  delete params.back
  delete params.month
  delete params.date
  return `/${profileSlug}${buildQuery(params, { addQueryPrefix: true })}`
}
